var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5242 15.5242 20 10 20C4.47581 20 0 15.5242 0 10C0 4.47581 4.47581 0 10 0C15.5242 0 20 4.47581 20 10ZM15.1613 10.6452C15.1613 10.9113 14.9435 11.129 14.6774 11.129H11.129V14.6774C11.129 14.9435 10.9113 15.1613 10.6452 15.1613H9.35484C9.08871 15.1613 8.87097 14.9435 8.87097 14.6774V11.129H5.32258C5.05645 11.129 4.83871 10.9113 4.83871 10.6452V9.35484C4.83871 9.08871 5.05645 8.87097 5.32258 8.87097H8.87097V5.32258C8.87097 5.05645 9.08871 4.83871 9.35484 4.83871H10.6452C10.9113 4.83871 11.129 5.05645 11.129 5.32258V8.87097H14.6774C14.9435 8.87097 15.1613 9.08871 15.1613 9.35484V10.6452ZM10 1.93548C14.4556 1.93548 18.0645 5.54435 18.0645 10C18.0645 14.4556 14.4556 18.0645 10 18.0645C5.54435 18.0645 1.93548 14.4556 1.93548 10C1.93548 5.54435 5.54435 1.93548 10 1.93548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.84151b8d2202f04ae7103f9622d22b70.svg";
export { ForwardRef as ReactComponent };